import {Styled, View} from '@unthinkable/react-core-components';

export const LoaderAbsoluteContainer = Styled(View)`
position: absolute;
top:50%;
left:58%;
`;
